import { attrConfig as rsidDelConfig } from './w-rsid-del.js';
import { attrConfig as rsidPConfig } from './w-rsid-p.js';
import { attrConfig as rsidRConfig } from './w-rsid-r.js';
import { attrConfig as rsidRPrConfig } from './w-rsid-r-pr.js';
import { attrConfig as rsidRDefaultConfig } from './w-rsid-r-default.js';
import { attrConfig as w14ParaIdConfig } from './w14-para-id.js';
import { attrConfig as w14TextIdConfig } from './w14-text-id.js';

/** @type {import('@translator').AttrConfig[]} */
export default [
  w14ParaIdConfig,
  w14TextIdConfig,
  rsidRConfig,
  rsidRDefaultConfig,
  rsidPConfig,
  rsidRPrConfig,
  rsidDelConfig,
];
